import Flickity from 'flickity';
import App from '../index';

const Gallery = {
    content: null,
    flkty: [],
    load: true,
    init: () => {
        Gallery.gallery = document.querySelector("#gallery");
        Gallery.content = document.querySelectorAll(".carousel");
        Gallery.cell = document.querySelectorAll(".carousel-cell");
        Gallery.bind();
    },
    bind: (e) => {
        if (Gallery.content) {
            Gallery.content.forEach(function(item, index) {
                let loop = item.getAttribute("data-loop")
                if (loop != "false") {
                    Gallery.flkty[index] = new Flickity(item, {
                        cellAlign: 'left',
                        contain: true,
                        pageDots: false,
                        prevNextButtons: App.isMobile,
                        draggable: true,
                        wrapAround: true,
                        autoPlay: loop,
                        setGallerySize: true,
                        // daptiveHeight: true,
                        lazyLoad: true
                    });
                } else {
                    Gallery.flkty[index] = new Flickity(item, {
                        cellAlign: 'left',
                        contain: true,
                        pageDots: false,
                        prevNextButtons: App.isMobile,
                        draggable: true,
                        wrapAround: true,
                        setGallerySize: true,
                        // daptiveHeight: true,
                        lazyLoad: true
                    });
                }



                let currentGallery = Gallery.flkty[index];

                let currentGalleryId = item.getAttribute("data-id")
                let numbers = document.querySelector("#carousel-numbers-" + currentGalleryId);

                if (numbers) {
                    let numbersChild = numbers.children;
                    numbersChild[1].innerHTML = `${currentGallery.cells.length}`;

                    Gallery.flkty[index].on('change', function(index) {
                        numbersChild[0].innerHTML = `${currentGallery.selectedIndex + 1}`;
                    });
                }
                
                Gallery.flkty[index].on('staticClick', function(e, pointer, cellElement, cellIndex) {
                    if (e.clientX > (item.clientWidth / 2)) { currentGallery.next(); } else { currentGallery.previous(); }
                });


            });

            Gallery.load = true;
        }


        if (Gallery.gallery) {
            Gallery.gallery.addEventListener("mousemove", function(e) {
                Gallery.mousemove(Gallery.gallery, e);
            });

            Gallery.gallery.addEventListener("mouseleave", function(e) {
                Gallery.mouseleave(e);
            });

            window.addEventListener('scroll', function(e) {
                Gallery.mouseleave(e);
            });

        }



    },
    mousemove: (content, e) => {
        let cursor = document.querySelector("#cursor");
        let label = document.querySelector("#label");
        cursor.style.opacity = '1';
        var m_posx = 0,
            m_posy = 0,
            e_posx = 0,
            e_posy = 0,
            obj = content;
        //get mouse position on document crossbrowser
        if (!e) { e = window.event; }
        if (e.pageX || e.pageY) {
            m_posx = e.pageX;
            m_posy = e.pageY;
        } else if (e.clientX || e.clientY) {
            m_posx = e.clientX + document.body.scrollLeft +
                document.documentElement.scrollLeft;
            m_posy = e.clientY + document.body.scrollTop +
                document.documentElement.scrollTop;
        }
        //get parent element position in document
        if (obj.offsetParent) {
            do {
                e_posx += obj.offsetLeft;
                e_posy += obj.offsetTop;
            } while (obj = obj.offsetParent);
        }
        let width = content.offsetWidth;
        // mouse position minus elm position is mouseposition relative to element:
        // dbg.innerHTML = ' X Position: ' + (m_posx - e_posx) +' Y Position: ' + (m_posy - e_posy);
        let x = m_posx - e_posx;
        let y = m_posy - e_posy;
        cursor.style.transform = `translate(${x}px, ${y }px)`;
        if (x > (width / 2)) {
            document.querySelector("#arrow-right").classList.add("active");
            document.querySelector("#arrow-left").classList.remove("active");
            // label.innerHTML = "<img class='arrow arrow-right' src='http://ecstudio.0x000.ch/src/img/arrow-right.png'  alt='arrow' />";
        } else {
            document.querySelector("#arrow-right").classList.remove("active");
            document.querySelector("#arrow-left").classList.add("active");
            // label.innerHTML = "<img class='arrow arrow-left' src='http://ecstudio.0x000.ch/src/img/arrow-left.png'   alt='arrow' />";
        }

    },

    mouseleave: (e) => {
        let cursor = document.querySelector("#cursor");
        let label = document.querySelector("#label");
        cursor.style.opacity = '0';
    }

}
export default Gallery;